import { QRCodeCanvas } from 'qrcode.react';
import React, { useEffect } from 'react';
import { setQRImage } from '../../store/form';
import { useAppDispatch } from '../../store/hooks';
import styles from './QRCode.module.scss';

export type QRCodeProps = {
    link: string;
    testId?: string;
};

const QRCode = ({ link, testId }: QRCodeProps) => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        const canvas = document.querySelector(`.${styles.qr}`) as HTMLCanvasElement;
        dispatch(setQRImage(canvas.toDataURL()));
    }, [dispatch, link]);
    return (
        <div className={styles.container} data-testid={testId}>
            <QRCodeCanvas value={link} className={styles.qr} />
        </div>
    );
};

export default QRCode;
